import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SupplierService} from 'app/shared/services/supplier.service';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';


@Component({
  selector: 'app-add-supplier',
  templateUrl: './add-supplier.component.html',
  styleUrls: ['./add-supplier.component.css']
})
export class AddSupplierComponent implements OnInit {

  isDark: boolean = false;
  isShowAttachBtn: boolean=false;

  addSupplierForm: FormGroup;
  isSaveBtnDisabled : boolean= false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  
  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  validationMessages = {
    'supId': { 'required': 'Supplier Id is required' },
    'supName': { 'required': 'Supplier name is required' },
    'address': { 'required': 'Address is required' },
    'phone': { 'required': 'Phone Number is required' },
    'email': {'email': 'Email must be a valid email address'},   
  };

  formErrors = {
    'supId': "",
    'supName': "",
    'address': "",
    'phone': "",
    'email': "",
  };



    constructor(private fb: FormBuilder,
                private supplierService: SupplierService,
                private router : Router, 
                private toastr: ToastrService,
                private fileUploadService:FileUploadService,
                private dialogService: DialogService,
                private authService: AuthService,
                private themeService: NbThemeService,
              ) 
            {  } // end constructor
   

           

  ngOnInit() {

    this.addSupplierForm = this.fb.group({
      id : [null],
      supId : ['', Validators.required],
      supName : ['', Validators.required],
      address : ['', Validators.required],
      vatNo : [''],
      svatNo : [''],
      phone : ['', Validators.required],
      email : ['', [Validators.email]],
      paymentDetails : [''],
      status : [false],
      createdBy : [''],

    });


   this.addSupplierForm.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.addSupplierForm);
  });

  
  this.getDataTableRowData();
  this.getControlPermissions();
  this.themeService.onThemeChange()
  .subscribe(themeName =>{
       this.isDark  = themeName.name ==='dark' ? true : false;
     });


  } //end OnInit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='SM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.addSupplierForm.value.supId;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }
  

  newButtonClick(): void {
    this.isSaveBtnDisabled = false;
    this.isShowAttachBtn=false; 
    this.addSupplierForm.reset();
    this.enableForm();
    this.getMaxId();
   }

   
  
   getMaxId(){
    var supplierId = 0;
    var sSupplierId : String;
  
    this.supplierService.getMaxId()
    .subscribe(
      (res) => {
                  supplierId = Number(res[0].MaxId) + 1;
                  sSupplierId = supplierId.toString().padStart(6,'0');
                  this.addSupplierForm.patchValue({
                    supId : "SUP" + sSupplierId
                  });

                },        
      (err) =>  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                }, 
      )



   }

  saveButtonClick(): void {

    this.logValidationErrors(this.addSupplierForm,true);
    const formData = this.mapFormValuesToSupplierModel();  

          if(this.isFilledFromFields()){

            if(!this.addSupplierForm.value.id){
              this.showProcessingIndicator = true;
              this.supplierService.addSupplier(formData)
              .subscribe(
                (res) => {                            
                            if(res.success === 0){
                              this.addSupplierForm.patchValue({
                              supId : res.autoId
                              });
                            this.saveButtonClick();
                            this.showProcessingIndicator = false; 
                            
                            }else if(res.success === 1){
                              this.toastr.success('Record created successfully','Success');
                              this.showProcessingIndicator = false; 
                              this.isShowAttachBtn = true;
                              this.newButtonClick();   
                           } 
                          },        
                (err) =>  {
                            this.toastr.error('Failed to created record','Failure');                            
                            this.showProcessingIndicator = false;
                            if(err instanceof HttpErrorResponse){                 
                              if(err.status == 401){
                                this.router.navigate(['/login']);
                              }
                            }
                            console.log(err);
                          }, 
                )

            }else{
              this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.supplierService.updateSupplier(formData)
              .subscribe(
                (res) => {
                            this.toastr.success('Record updated successfully','Success');    
                            this.showProcessingIndicator = false;  
                            this.newButtonClick();
                          },        
                (err) =>  {
                            this.toastr.error('Failed to update record','Failure');
                            this.showProcessingIndicator = false;
                            if(err instanceof HttpErrorResponse){                 
                              if(err.status == 401){
                                this.router.navigate(['/login']);
                              }
                            }
                            console.log(err);
                          }, 
                )

               }
              })

            }       

          }
          else{
            this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');                    
          }
           
          this.showProcessingIndicator = false;         
   }


  


   enableForm():void{
    Object.keys(this.addSupplierForm.controls).forEach(key => {
      this.addSupplierForm.controls[key].enable();
     // console.log(key)
    });
  }


 
  
  logValidationErrors(group: FormGroup = this.addSupplierForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.addSupplierForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
}

mapFormValuesToSupplierModel(){
  let status;
  if(this.addSupplierForm.value.status){
    status='Deactivated';    
  }
  else{
    status='Active';
  }  
  let formData ={
    ...this.addSupplierForm.value,
    status : status,
    createdBy : this.authService.getUserLoggedIn(),
  }

  return formData;
  
}




  
activeStatus = false;
viewSupplier(supplier){
  if(supplier.Status=='Active'){
    this.activeStatus = false;
  }else{
    this.activeStatus = true;
  }
 
  this.addSupplierForm.patchValue({
    id : supplier.Id,
    supId : supplier.SupId,
    supName :supplier.SupName,
    address : supplier.Address,
    vatNo : supplier.VATNo,
    svatNo : supplier.SVATNo,
    phone : supplier.Phone, 
    email : supplier.Email,
    paymentDetails : supplier.PaymentDetails,
    status : this.activeStatus,    
   
  })
  this.isShowAttachBtn = true;
}

getDataTableRowData(){
  var data = this.supplierService.dataRow;
  if(data){
    this.viewSupplier(data);
  }
  else{
    this.newButtonClick();
  }

}



} //end class

